import SeverityInput from './SeverityInput';
import YesNoInput from './YesNoInput';

export default function AssessmentItem({ item, value, onChange }) {
    const renderInput = () => {
        switch (item.type) {
            case 'severity_0_3':
                return <SeverityInput value={value} onChange={onChange} />;
            case 'yes_no':
                return <YesNoInput value={value} onChange={onChange} />;
            default:
                return null;
        }
    };

    return (
        <div className="assessment-item">
            <p className="assessment-item-text">{item.text}</p>
            {renderInput()}
        </div>
    );
}
